import { render, staticRenderFns } from "./FormatDetailList.vue?vue&type=template&id=0653c412"
import script from "./FormatDetailList.vue?vue&type=script&lang=js"
export * from "./FormatDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports